export const REFUND_SUBMISSION_STRINGS: Record<string, [string, string, string]> = {
  'rf.submitting': ['正在送出申請', 'Submitting application', '申請を送信中'],
  'rf.accepted': ['退票申請受理成功', 'Refund application accepted', '払戻申請を受け付けました'],
  'rf.acceptedNote': [
    '受理不代表已退款，請查看退款進度。',
    'Acceptance does not mean payment is complete. Check refund progress.',
    '受付は返金完了ではありません。払戻状況をご確認ください。',
  ],
  'rf.changed': ['金額已更新', 'Refund amount updated', '払戻金額が更新されました'],
  'rf.manualAcceptedNote': [
    '申請已送交櫃檯人工審核，尚未核准退款。請攜帶完整套票至服務櫃檯確認退票範圍與金額。',
    'Your application is awaiting staff review; no refund has been approved. Bring all package tickets to the counter to confirm the tickets and amount to refund.',
    '申請は窓口での審査待ちで、返金はまだ承認されていません。セット券をすべて窓口へお持ちになり、対象券と金額をご確認ください。',
  ],
  'rf.changedNote': [
    '請核對更新後的金額與扣款，返回重新確認並勾選同意。',
    'Review the updated amount and deductions, then confirm and agree again.',
    '更新された金額と控除を確認し、再度同意してください。',
  ],
  'rf.pending': [
    '申請結果待確認',
    'Application result pending confirmation',
    '申請結果の確認が必要です',
  ],
  'rf.pendingNote': [
    '連線中斷不代表申請失敗。請確認本次申請結果；仍無法確認時可洽現場人員，離開後可重新掃原票查詢退款進度。',
    'A lost connection does not mean failure. Check this application, or ask staff. After leaving, scan the original ticket to check progress.',
    '通信切断は申請失敗を意味しません。今回の結果をご確認ください。不明な場合は係員へ。終了後は元の乗船券で状況を確認できます。',
  ],
  'rf.check': ['確認本次申請結果', 'Check this application', '今回の申請結果を確認'],
  'rf.progress': ['查看退款進度', 'View refund progress', '払戻状況を見る'],
  'rf.failed': [
    '申請未受理，請返回重新操作。',
    'Application was not accepted. Return to start again.',
    '申請は受け付けられていません。戻ってやり直してください。',
  ],
  'rf.termsUnavailable': [
    '無法取得最新同意條款，請重新整理或洽現場服務人員。',
    'Current terms are unavailable. Reload or ask staff for assistance.',
    '最新の同意事項を取得できません。再読み込みするか係員へご相談ください。',
  ],
  'rf.termsUpdated': [
    '同意條款已更新，請閱讀全文並重新勾選。',
    'Terms have changed. Read the full text and agree again.',
    '同意事項が更新されました。全文を読み、再度同意してください。',
  ],
  'rf.reference': ['申請編號', 'Application reference', '申請番号'],
  'rf.existing': ['已有退款申請', 'An application already exists', '払戻申請があります'],
  'rf.loadingTerms': ['正在取得同意條款', 'Loading terms', '同意事項を取得中'],
  'rf.progressError': [
    '暫時無法查詢此案件，請稍後再試。',
    'Unable to check this case. Please try again.',
    'この申請を確認できません。再度お試しください。',
  ],
};
